import module from '../module';
import Constants from '../../../utils/CommonConstants';
import scopeUtils from '../../../utils/scope';
import moment from 'moment';
import * as _ from "lodash";
import {communicationService} from "../../../services/communicationService";
import {commandKeys} from "../../../shared/commandKeys";
import CommonConstants from "../../../utils/CommonConstants";

require('moment-timezone');

export class OrderTabPreviewController {
  static $inject = ['$scope', 'cartonomyConfig', 'CartService', '$q', 'Message', 'ConfigurationService', 'GroupOrder', 'CheckoutService', '$rootScope', '$mdSelect', '$translate'];

  constructor(scope, cartonomyConfig, cartService, qService, messageService, configurationService, groupOrderService, checkoutService, rootScope, mdSelect, $translate) {

    this._scope = scope;

    this._cartService = cartService;
    this._cartonomyConfig = cartonomyConfig;
    this._qService = qService;
    this._messageService = messageService;
    this._groupOrderService = groupOrderService;
    this._configurationService = configurationService;
    this._checkoutService = checkoutService;
    this._rootScope = rootScope;
    this._mdSelect = mdSelect;
    this.$translate = $translate;

    scope.externalStoreMode = cartonomyConfig.externalStoreMode;
    scope.maxAllowedBudget = 100000;

    scope.readOnly = false;
    scope.errorMessage = '';

    scope.editDeliveryInfo = () => scope.previewTab('deliveryAddress');
    scope.editOrderDeadline = () => scope.previewTab('deadline');
    scope.editInvitees = () => scope.previewTab('addPeople');
    scope.editBudget = () => scope.previewTab('budget');
    scope.createOrderAndSendInvites = () => this._createOrderAndSendInvites();
    scope.acceptSinglePayOrderNoBudget = form => this._acceptSinglePayOrderNoBudget(form);
    scope.acceptSinglePayOrderNoPayment = form => this._acceptSinglePayOrderNoPayment(form);
    scope.onBudgetChanged = () => this._onBudgetChanged();
    scope.acceptSinglePayOrderBudget = form => this._acceptSinglePayOrderBudget(form);
    scope.acceptPaymentInformation = () => this._acceptPaymentInformation();
    scope.shouldDisablePaymentInformationNextButton = () => this._shouldDisablePaymentInformationNextButton();
    scope.saveAndGoNext = () => this._saveAndGoNext();
    scope.onDeadlineDateChanged = () => this._onDeadlineDateChanged();
    scope.onMdSelectOpen = () => this._onMdSelectOpen();
    scope.onMdSelectClose = () => this._onMdSelectClose();

    scope.cartNameChange = () => this._cartNameChange();
    scope.orderModel = {
      cartNameValue :  $translate.instant(Constants.CART_NAME_DEFAULT_VALUE),
      isValid: true,
      deadlineDate: null,
      deadlineTime: null,
      customCartName : '0'
    };

    scope.deliverTimeValues = [];

    scope.modelValidation = {
      budget: true,
      deadlineDate: true,
      deadlineTime: true,
      deliveryDate: true
    };

    scope.isGeneralMillsPOC = false;

    scope.currencySymbol = this._rootScope.moneyFormat.replace('{{amount}}', '');

    scope.$watch('configuration.paymentSystem', paymentSystem => this._onPaymentSystemChanged(paymentSystem));
  }

  async $onInit() {
    this._scope.orderModel.customCartName = this._rootScope.retailer.customCartNames;
    this._scope.configuration = {
      delivery: this._groupOrderService.getDeliveryMode(),
      groupPay: this._groupOrderService.getGroupPay(),
      paymentMethod: Constants.CartDetails.PaymentMethods.SINGLE,
      singlePayOrder: this._groupOrderService.getSinglePayOrder(),
      contactDetails: this._groupOrderService.getContactDetails(),
      deliveryDetails: this._groupOrderService.getDeliveryDetails(),
      deliveryAddress: this._groupOrderService.getDeliveryAddress()
    };


    this._scope.canChangeDeadline = this._rootScope.retailer.cartonomyMode !== CommonConstants.CartonomyMode.marketing;
    this._scope.hasDeliveryDate = this._rootScope.retailer.hasDeliveryDate;
    this._scope.createInstruction = this._rootScope.retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing ? 'client.user.marketing' : 'client.user.marketing_link';
    this._scope.marketingMode = this._rootScope.retailer.cartonomyMode === CommonConstants.CartonomyMode.marketing;

    this._scope.invitedPeopleCount = this._scope.configuration.contactDetails != null ? this._scope.configuration.contactDetails.selectedEmails.length : 0;
    if (!this._scope.configuration.delivery) {
      this._scope.pickup = {};
      this._configurationService.getItem('pickupAddress')
        .then((pickupAddress) => {
          this._scope.pickup.address = pickupAddress;
          scopeUtils.apply(this._scope);
        });
    }

    if (this._scope._editMode) {
      this.cart = await this._cartService.getCart();
      this._scope.orderModel.cartNameValue = this.cart.cartName || this.$translate.instant(Constants.CART_NAME_DEFAULT_VALUE);

      if (!this._scope.configuration.singlePayOrder.budget) {
        this._scope.configuration.singlePayOrder.budget = this.cart.orderLimit;
      }
    }

    if ((_.isString(this._scope.configuration.singlePayOrder.budget) &&
        this._scope.configuration.singlePayOrder.budget.match(/^\d/)) || (this._scope.configuration.singlePayOrder.budget > 0 )) {
      this._scope.configuration.singlePayOrder.budget = parseFloat(this._scope.configuration.singlePayOrder.budget);
      this._scope.configuration.singlePayOrder.defineBudget = 'yes';
      this._scope.configuration.singlePayOrder.budgetEntered = true;
    } else {
      this._scope.configuration.singlePayOrder.budget = "";
      this._scope.configuration.singlePayOrder.defineBudget = 'no';
    }

    this._scope.configuration.paymentProvided = await this._checkoutService.paymentAuthorizedOrCaptured();

    if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
      this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
    }

    //Retailer Link
    this.retailer = this._configurationService.getRetailer().retailer;
    this.retailerTimezone = this.retailer.timeZoneSettingName;
    await this._setupDeliveryTime();

    this._scope.isSelectPaymentType = this.retailer.paymentType === Constants.CartDetails.PaymentMethods.USER_SELECT;
    this._scope.isSelectBudgetType = this.retailer.budgetType === Constants.CartDetails.BudgetTypes.USER_SELECT;
    this._scope.isGeneralMillsPOC = this.retailer && Constants.GENERAL_MILLS_POC.some((poc) => { return this.retailer.name.indexOf(poc) > -1});

    this._scope.configuration.singlePayOrder.budgetType = this._scope.isSelectBudgetType ? Constants.CartDetails.BudgetTypes.PER_CART : this.retailer.budgetType;

    scopeUtils.apply(this._scope);

  }

  _deadlineExpired = () => {
    if (!this._scope.configuration.deliveryDetails.deadlineTime) {
      return false;
    }
    const deadlineTime = moment(this._scope.configuration.deliveryDetails.deadlineTime).subtract(15, 'minutes').toDate();
    return moment().isAfter(deadlineTime);
  };

  async _createOrderAndSendInvites() {
    if (this._scope.hasDeliveryDate && !this._scope.configuration.deliveryDetails.deliveryTime) {
      this._scope.modelValidation.deliveryDate = false;
      return;
    }
    let response = await communicationService.requestToParent(commandKeys.createNewGroupOrder);
    if(!response || !response.success) {
      this._scope.errorMessage =  response && response.errorMessage || this.$translate.instant('client.order.error_parent');
      this._scope.readOnly = true;
      return;
    }

    if (this._deadlineExpired()) {
      this._scope.errorMessage = this.$translate.instant('client.order.deadline_expired', {delivery: (this._scope.configuration.delivery ? 'delivery' : 'pickup')});
      this._scope.readOnly = true;
      return;
    }

    this._scope.readOnly = true;
    this._scope.errorMessage = '';

    try {
      await this._cartService.setInvitationType(Constants.InvitationTypes.share);
      await this._submitOrder(response.data);
    } finally {
      this._scope.readOnly = false;
    }
  }

  async _submitOrder(data) {
    this._scope.invitationCode = this._cartService.getInviteCode();
    if(!this._scope.invitationCode)
    {
      this._scope.invitationCode = await this._cartService.getInvitationCode();
      this._cartService.setInviteCode(this._scope.invitationCode);
      this._cartService.setInvitationType(Constants.InvitationTypes.share);
    }

    await this._saveOrderInfo();
    if(!this._isModelValid()) {
      return;
    }

    this._groupOrderService.setDeliveryDetails(this._scope.configuration.deliveryDetails);

    try {
      await this._groupOrderService.save(data);
      await this._groupOrderService.sendInvites();
      await this._cartService.resetCart();
      this._scope.setCurrentTabById('finish');
      scopeUtils.apply(this._scope);
    } catch (error) {
      this._scope.errorMessage = this._messageService.getMessageFromErrorResponse(error) || this.$translate.instant('client.order.cart_not_update');
    }
  }

  async _saveAndGoNext() {
    if(!this._isModelValid()) {
      return;
    }
    await this._saveOrderInfo();
    this._scope.next();
  }

  async _saveOrderInfo() {
    if(this._scope._editMode && this._scope.configuration.singlePayOrder.budget && this.cart.cartTotal < this._scope.configuration.singlePayOrder.budget) {
      this._scope.configuration.singlePayOrder.budgetInvalid = true;
    }
    if (this._scope.configuration.singlePayOrder.budget) {
      await this._acceptSinglePayOrderBudget();
    } else {
      await this._acceptSinglePayOrderNoBudget();
    }
    await this.saveDeadline();
    await this.saveCartName();
    this._groupOrderService.setPaymentMethod(this._scope.configuration.paymentMethod);
  }

  async _setupDeliveryTime() {
    this._scope.configuration.deliveryDetails.placeDateAndTime =
        this._scope.configuration.deliveryDetails.placeDateAndTime ||
        this._scope.configuration.deliveryDetails.deadlineTime;

    let placeDateAndTime = this._scope.configuration.deliveryDetails.placeDateAndTime;
    this._scope.closeOn = placeDateAndTime ? moment.tz(placeDateAndTime, this.retailerTimezone).format('ddd[,] MMM Do[,] LT') + this.retailer.timeZoneDisplayName : '';

    let minimumTime = moment().add(15, 'minutes');
    let minimumDeliveryTime = moment().add(90, 'minutes');
    let minimumDate = moment.tz(minimumTime,this.retailerTimezone).startOf('day');

    let maximumTime = null;

    if (!this._scope._editMode || this._cartonomyConfig.externalStoreMode) {
      maximumTime = moment().clone().add('3', 'years').endOf('day');
    } else if (this._scope.configuration.deliveryDetails.deadlineTime && !this._cartonomyConfig.externalStoreMode) {
      maximumTime = moment(this._scope.configuration.deliveryDetails.deadlineTime);
    } else {
      maximumTime = moment().clone().endOf('day');
    }

    let maximumDate = maximumTime.clone().endOf('day');

    this._scope.minimumDate = minimumDate.toDate();
    this._scope.maximumDate = maximumDate.toDate();

    if(placeDateAndTime) {
      this._scope.configuration.deliveryDetails.placeDate = moment(placeDateAndTime).toDate();
    }

    if (placeDateAndTime && moment(placeDateAndTime).isValid()) {
      this._scope.configuration.deliveryDetails.placeTime = moment(placeDateAndTime).format();

      this._scope.configuration.deliveryDetails.defineDeadline = true;
    } else {
      this._scope.configuration.deliveryDetails.defineDeadline = false;
    }

    let getTimeValues = (date, minimumTime, maximumTime) => {

      let currentDate = moment(date).startOf('day');
      let endDate = currentDate.clone().endOf('day');

      let list = [];

      for (; currentDate.isSameOrBefore(endDate); currentDate.add(30, 'minutes')) {
        var _minimumTime = moment(minimumTime);
        var _maximumTime = moment(maximumTime);
        if (currentDate.isBetween(_minimumTime, _maximumTime, 'minutes', '[]')) {

          let value = currentDate.format();
          list.push({
            text: currentDate.format('LT'),
            value: value
          });
        }
      }

      return list;
    };

    this._scope.acceptedDateFilter = date => {
      date = moment(date).format('YYYY-MM-DD');
      date = moment.tz(date,this.retailerTimezone);
      return date.isSameOrAfter(minimumDate);
    };

    // regular mode will have expire time assigned, shopify mode should not have
    if (!this._cartonomyConfig.externalStoreMode) {
      let timeValues = getTimeValues(maximumDate, minimumTime, maximumTime);

      if (timeValues.length && !placeDateAndTime) {
        this._scope.configuration.deliveryDetails.placeTime = timeValues[ timeValues.length - 1 ].value;
      }
    }


    if (this._scope.configuration.deliveryDetails.deliveryDate) {
      this._scope.configuration.deliveryDetails._deliveryDate = moment.utc(this._scope.configuration.deliveryDetails.deliveryDate).local().toDate();
      this._scope.configuration.deliveryDetails.deliveryTime = moment.utc(this._scope.configuration.deliveryDetails.deliveryTime).local().format();
    }


    this._scope.$watch('configuration.deliveryDetails._deliveryDate', (newValue) => {
      if (!newValue)
        return;

      this._scope.configuration.deliveryDetails.deliveryDate = this._scope.configuration.deliveryDetails._deliveryDate;
      this._scope.deliverTimeValues = getTimeValues(newValue, minimumDeliveryTime, maximumDate);

      if (this._scope.configuration.deliveryDetails.deliveryTime
        && moment.utc(this._scope.configuration.deliveryDetails.deliveryTime).local()
          .isSame(moment.utc(this._scope.configuration.deliveryDetails._deliveryDate).local(), 'day')) {
        this._scope.configuration.deliveryDetails.deliveryTime = moment.utc(this._scope.configuration.deliveryDetails.deliveryTime).local().format();
      } else {
        this._scope.configuration.deliveryDetails.deliveryTime = this._scope.deliverTimeValues[0].value;
      }
      scopeUtils.apply(this._scope);
    });

    this._scope.$watch('configuration.deliveryDetails.placeDate', (newValue) => {
      if (!newValue)
        return;

      let timeValues = getTimeValues(newValue, minimumTime, maximumTime);
      this._scope.timeValues = timeValues;

      if (!placeDateAndTime) {
        this._scope.configuration.deliveryDetails.placeTime = timeValues[ timeValues.length - 1 ].value;
      }
      scopeUtils.apply(this._scope);
    });
  }

  async _acceptPaymentInformation() {
    switch (this._scope.configuration.paymentSystem) {
      case 'PayPal':
        return this._onPaypalSelected();
      case 'Square':
        return await this._onCreditCardSelected();
    }
  }

  async _acceptSinglePayOrderNoPayment() {
    this._scope.budgetExceeds = false;
    this._scope.budgetMaximumReach = false;
    await this._onBudgetChanged();

    if (!this._scope.budgetExceeds && !this._scope.budgetMaximumReach) {
      this.saveBudget();
    }
  }

  async _onBudgetChanged() {
    if (this._scope.configuration.singlePayOrder.budget && _.isString(this._scope.configuration.singlePayOrder.budget)) {
      this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
      this._scope.configuration.singlePayOrder.budgetEntered = true;
    } else {
      this._scope.configuration.singlePayOrder.budgetEntered = false;
    }

    if (this._scope.externalStoreMode && !this._scope.configuration.singlePayOrder.enterPaymentInformation) {
      this._scope.configuration.singlePayOrder.enterPaymentInformation = 'no';
    }

    this._scope.budgetExceeds = false;
    this._scope.budgetMaximumReach = false;

    let currentAmount = await this._cartService.getCartAmount();
    if (this._scope.configuration.singlePayOrder.budget < currentAmount) {
      this._scope.budgetExceeds = currentAmount;
    }
    if (this._scope.configuration.singlePayOrder.budget > this._scope.maxAllowedBudget) {
      this._scope.budgetMaximumReach = true;
    }
    this._scope.modelValidation.budget = !(!!this._scope.configuration.singlePayOrder.budget && ( this._scope.budgetExceeds || this._scope.budgetMaximumReach));
    scopeUtils.apply(this._scope);
  }

  async _acceptSinglePayOrderBudget() {
    // only digits and decimal point
    if (_.isString(this._scope.configuration.singlePayOrder.budget)) {
      this._scope.configuration.singlePayOrder.budget = this._scope.configuration.singlePayOrder.budget.replace(/[^0-9.]/g, "");
      this._scope.configuration.singlePayOrder.budgetEntered = true;
    } else {
      await this.saveBudget();
    }
  }

  async _acceptSinglePayOrderNoBudget() {
    this._scope.configuration.singlePayOrder.budget = 0;
    await this.saveBudget();
    scopeUtils.apply(this._scope);
  }


  _shouldDisablePaymentInformationNextButton() {
    if (!this._scope.configuration.paymentSystem) {
      return true;
    }

    if (this._scope.configuration.paymentSystem
        && this._scope.configuration.paymentSystem == 'PayPal'
        && !this._scope.configuration.vendorDetails.clientToken) {

      return true;
    }

    return this._scope.configuration.paymentSystem == '';
  }

  _onPaypalSelected() {
    this._scope.processingPayment = true;
    this.saveBudget();
    this._groupOrderService.saveToSessionStorage();
    window.location.href = Constants.PAYPAL_CHECKOUT_URL + this._scope.configuration.vendorDetails.clientToken;
  }

  async _onCreditCardSelected() {

    this._scope.processingPayment = true;
    this._scope.paymentSystemError = '';
    scopeUtils.apply(this._scope);

    try {

      this._scope.configuration.vendorDetails = await this._scope.configuration.getCardNonce();
      this._scope.configuration.vendorDetails.isAuthorization = true;
      this._scope.configuration.vendorDetails.orderTotal = this._scope.configuration.singlePayOrder.budget;

      await this._checkoutService.submitOrder(this._scope.configuration.paymentSystem,
          this._scope.configuration.vendorDetails);

    } catch (error) {
      this._scope.paymentSystemError = "client.payment.credit_trans_not_approved";

      this._scope.processingPayment = false;
      scopeUtils.apply(this._scope);
      return null;
    }

    this._scope.processingPayment = false;
    scopeUtils.apply(this._scope);

    this.saveBudget();
  }

  async _onPaymentSystemChanged(paymentSystem) {

    if (!paymentSystem) {
      this._scope.processingPayment = false;
      return null;
    }

    this._scope.processingPayment = true;
    this._scope.paymentSystemError = '';
    scopeUtils.apply(this._scope);

    try {
      await this._groupOrderService.save();
      const paymentConfiguration = await this._checkoutService.beginCheckout(paymentSystem);
      this._scope.configuration.vendorDetails.clientToken = paymentConfiguration.clientToken;
    } catch (error) {
      this._scope.paymentSystemError = this._messageService.getMessageFromErrorResponse(error);
    }

    this._scope.processingPayment = false;
    scopeUtils.apply(this._scope);
  }

  _cartNameChange(){
    if(!this._scope.orderModel.cartNameValue){
      this._scope.orderModel.isValid = false;
    }else{
      this._scope.orderModel.isValid = true;
    }
  }

  addEventListenerOnce(target, type, listener, addOptions, removeOptions) {
    target.addEventListener(type, function fn(event) {
      target.removeEventListener(type, fn, removeOptions);
      listener.apply(this, arguments);
    }, addOptions);
  }

  __mdSelectBackdropCallback = () => {
    this._mdSelect.hide();
  };

  _onMdSelectOpen() {
    setTimeout(() => {
      this.addEventListenerOnce(document, "click", this.__mdSelectBackdropCallback, true);
    }, 500);
  }

  _onMdSelectClose() {
    document.removeEventListener("click", this.__mdSelectBackdropCallback, true);
  }

  _onDeadlineDateChanged() {
    this._scope.modelValidation.deadlineDate = (!this._scope.configuration.deliveryDetails.placeTime && !this._scope.configuration.deliveryDetails.placeDate)
        || (!this._scope.configuration.deliveryDetails.placeTime || this._scope.configuration.deliveryDetails.placeDate);
    this._scope.modelValidation.deadlineTime = (!this._scope.configuration.deliveryDetails.placeTime && !this._scope.configuration.deliveryDetails.placeDate)
        || (this._scope.configuration.deliveryDetails.placeTime || !this._scope.configuration.deliveryDetails.placeDate);
  }

  async saveBudget() {
    this._groupOrderService.setSinglePayOrder(this._scope.configuration.singlePayOrder);
    this._groupOrderService.setVendorDetails(this._scope.configuration.vendorDetails);
    this._groupOrderService.setPaymentSystem(this._scope.configuration.paymentSystem);
  }

  async saveDeadline() {
    if (this._scope.configuration.deliveryDetails.placeDate) {
      let deadline = moment(this._scope.configuration.deliveryDetails.placeDate);
      if (this._scope.configuration.deliveryDetails.placeTime) {
        let time = moment(this._scope.configuration.deliveryDetails.placeTime);
        deadline.hour(time.hour());
        deadline.minute(time.minute());
      } else {
        deadline.hour(0);
        deadline.minute(0);
      }
      this._scope.configuration.deliveryDetails.deadlineTime = moment.tz(deadline, this.retailerTimezone).format();
    } else {
      this._scope.configuration.deliveryDetails.deadlineTime = null;
    }
    this._groupOrderService.setDeliveryDetails(this._scope.configuration.deliveryDetails);
  }

  async saveCartName() {
    if(this._scope.orderModel.customCartName === '1' && !this._scope.orderModel.cartNameValue){
      this._scope.orderModel.isValid = false;
      return;
    }
    this._groupOrderService.setCustomCartName(this._scope.orderModel.customCartName,this._scope.orderModel.cartNameValue);
  }

  _isModelValid() {
    return this._scope.modelValidation.budget && this._scope.modelValidation.deadlineDate && this._scope.modelValidation.deadlineTime;
  }

}

module.controller('OrderTabPreview', OrderTabPreviewController);



// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabPreviewController.js